// extracted by mini-css-extract-plugin
export default {"dateBtn":"SwitchDate_dateBtn__yRdsM","active":"SwitchDate_active__HRb9Q"};